import { Grid, Typography } from '@mui/material'
import { useFormat } from 'Services/localize/format'
import {
    TextBoxMobile,
    textFontStyle,
} from 'components/Sell/CalculationInput/CalculatePanelUI'

interface ICreditCardPanelMobile {
    tenderedAmount: number
}

function CreditCardPanelMobile({ tenderedAmount }: ICreditCardPanelMobile) {
    const { currency } = useFormat()

    return (
        <Grid container direction="column">
            <Grid item>
                <Typography color="primary" sx={textFontStyle} align="left">
                    Charge Amount:
                </Typography>
            </Grid>
            <TextBoxMobile item border={'1px solid default.main'}>
                <Typography
                    sx={{
                        marginTop: { xs: '8px', lg: '18px' },
                        marginRight: { xs: '16px', lg: '20px' },
                        ...textFontStyle,
                    }}
                >
                    {`${currency(tenderedAmount)}`}
                </Typography>
            </TextBoxMobile>
        </Grid>
    )
}
export default CreditCardPanelMobile
